import React from 'react';
import { Paper, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ApprovalStatusFilter as ApprovalStatusFilterValue } from '../../../services/ApprovalService';

export type InboxFilter = Exclude<ApprovalStatusFilterValue, 'all'>;

const FILTERS: { key: InboxFilter; label: string }[] = [
  { key: 'pending', label: 'Pending' },
  { key: 'approved', label: 'Approved' },
  { key: 'rejected', label: 'Rejected' },
  { key: 'expired', label: 'Expired' },
];

interface ApprovalStatusFilterProps {
  value: InboxFilter;
  onChange: (value: InboxFilter) => void;
}

const ApprovalStatusFilter: React.FC<ApprovalStatusFilterProps> = ({ value, onChange }) => (
  <Paper
    elevation={0}
    sx={{ p: 2, mb: 2, backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 1.5 }}
  >
    <ToggleButtonGroup
      value={value}
      exclusive
      size="small"
      onChange={(_, v) => v && onChange(v)}
    >
      {FILTERS.map((f) => (
        <ToggleButton key={f.key} value={f.key}>
          {f.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  </Paper>
);

export default ApprovalStatusFilter;
